import PropTypes from 'prop-types';
import React, { useEffect, useState } from 'react';

import Box              from '@mui/material/Box';
import Typography       from '@mui/material/Typography';

import WhatsAppIcon         from '@mui/icons-material/WhatsApp';
import MessengerIcon        from 'components/Generic/Icons/Messenger';
import SmsOutlinedIcon      from '@mui/icons-material/SmsOutlined';

import { Map, List } from 'immutable';

import Channel from 'components/LandingPage/CommunicationChannels/Channel';
import Display from 'components/Generic/Display';

function index({ ...props }) {
  const [state, setState] = useState(new Map());

  const company          = props.company; // WA and messenger validations are at company level
  const selectedChannels = state.get('selectedChannels', new List());

  const CHANNELS_CONTAINER_STYLE = {
    display:        'flex',
    flexDirection:  'row',
    justifyContent: 'space-around',
    alignItems:     'center',
    p:              2,
  };

  const MAIN_CONTAINER_STYLE = {
    display:        'flex',
    flexDirection:  'column',
    justifyContent: 'center',
    alignItems:     'center',
    p:              2,
  };

  useEffect(() => {
    props.onChange(selectedChannels);
  }, [selectedChannels]);

  const onChange = (channel) => {
    if (selectedChannels.includes(channel)) {
      const channelIndex = selectedChannels.findIndex((channelItem) => channelItem === channel);
      setState(state.set('selectedChannels', selectedChannels.delete(channelIndex)));
    } else {
      setState(state.set('selectedChannels', new List([channel])));
    }
  };

  if (!company.get('smsEnabled') && !company.get('whatsappEnabled') && !company.get('messengerEnabled')) return null;

  return (
    <Box sx={MAIN_CONTAINER_STYLE}>
      <Typography variant="p">{t('eos.landing_page.communication_channels.text')}</Typography>
      <Box sx={CHANNELS_CONTAINER_STYLE}>
        <Display if={company.get('whatsappEnabled')}>
          <Channel
            name={t('eos.landing_page.communication_channels.whatsapp')}
            identifier="whatsapp"
            icon={<WhatsAppIcon fontSize="large" />}
            checked={selectedChannels}
            onChange={onChange}
          />
        </Display>
        <Display if={company.get('messengerEnabled')}>
          <Channel
            name={t('eos.landing_page.communication_channels.messenger')}
            identifier="messenger"
            icon={<MessengerIcon fontSize="large" />}
            checked={selectedChannels}
            onChange={onChange}
          />
        </Display>
        <Display if={company.get('smsEnabled')}>
          <Channel
            name={t('eos.landing_page.communication_channels.sms')}
            identifier="sms"
            icon={<SmsOutlinedIcon fontSize="large" />}
            checked={selectedChannels}
            onChange={onChange}
          />
        </Display>
      </Box>
    </Box>
  );
}

index.defaultProps = {
  onChange: null,
};

index.propTypes = {
  onChange: PropTypes.func,
};

export default index;
